import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import attachStatementFolder from '../attachStatementFolder';
import attachStatementDocument from '../attachStatementDocument';
import controller from './attach-statement-dialog.controller';
import template from './attach-statement-dialog.html';


class dialogService {
  getOptions($event, { serviceId, criStatementId, assessmentId, folder }) {
    return {
      controller,
      controllerAs: 'attachStatementDialogVM',
      locals: {
        serviceId,
        criStatementId,
        assessmentId,
        folder
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.attachStatementDialog', [
  alerts,
  ecatDataService,
  attachStatementDocument,
  attachStatementFolder,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .service('attachStatementDialog', dialogService)
  .name;
